const locale = {
	VIEW_LEAVE_ITEM_RECOVERY_HOURS: 'Recovery hours: {dateRange}',
	VIEW_ITEM_LEAVE_REJECT: 'Reject',
	VIEW_ITEM_LEAVE_ACCEPT: 'Accept',

	// #region Leave fields
	DETAILS_LEAVE_FIELD_TITLE: 'Title',
	DETAILS_LEAVE_FIELD_STATUS: 'Leave Status',
	DETAILS_LEAVE_FIELD_TYPE: 'Leave Type',
	DETAILS_LEAVE_FIELD_USER: 'User',
	DETAILS_LEAVE_FIELD_WHOLE_DAY: 'Whole day',
	DETAILS_LEAVE_FIELD_DATE_FROM: 'Date from',
	DETAILS_LEAVE_FIELD_DATE_TO: 'Date to',
	DETAILS_LEAVE_FIELD_TIME_FROM: 'Time from',
	DETAILS_LEAVE_FIELD_TIME_TO: 'Time to',
	DETAILS_LEAVE_FIELD_RECOVERY_HOURS: 'Recovery hours',
	DETAILS_LEAVE_FIELD_RECOVERY_DATE_FROM: 'Recovery hours from',
	DETAILS_LEAVE_FIELD_RECOVERY_DATE_TO: 'Recovery hours to',
	DETAILS_LEAVE_FIELD_ASSIGNED_USER: 'Managed by',
	DETAILS_LEAVE_FIELD_REJECTED_REASON: 'Rejection reason',
	DETAILS_LEAVE_FIELD_TAGS: 'Tags',
	DETAILS_LEAVE_FIELD_WARNING: 'Warning',
	DETAILS_LEAVE_FIELD_BLOCKED: 'Blocked'
	// #endregion
};

export default locale;
